import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import AllAttributesTable from '../components/AllAttributesTable';
import { API_ENDPOINTS } from '../config/api';

const AllAttributesPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          All Player Attributes
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          View all players with their complete attributes - batters and pitchers combined.
        </Typography>
        <AllAttributesTable apiUrl={API_ENDPOINTS.ALL_ATTRIBUTES_PAGINATED} />
      </Box>
    </Container>
  );
};

export default AllAttributesPage;
